export default __webpack_public_path__ + "static/dog-ce3c4d37055377b3cbfcf8a1f41f3102.png";